<template>
  <strong>January 2023</strong>
</template>

<script>
  export default {
    name: 'AvailabilityDate'
  }
</script>
